import { useContext, useEffect, useState } from 'react';
import { LovDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';

const useCustomersForCarrier = (queryFilter: string) => {
  const [customers, setCustomers] = useState<LovDTO[]>([]);
  const { cuLovCustomersForCarrier } = useContext(ApiContext);
  useEffect(() => {
    cuLovCustomersForCarrier(queryFilter, data => setCustomers(data));
  }, []);
  return customers;
}

export default useCustomersForCarrier;